function keys(obj, hasKey) {
  var keys = [];

  for (var key in obj) {
    if (hasKey(obj, key)) {
      keys.push(key);
    }
  }

  return keys.concat(Object.getOwnPropertySymbols(obj).filter(symbol => Object.getOwnPropertyDescriptor(obj, symbol).enumerable));
}

function hasKey(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function hasDefinedKey(obj, key) {
  return hasKey(obj, key) && obj[key] !== undefined;
}

function isDomNode(obj) {
  return obj !== null && typeof obj === 'object' && typeof obj.nodeType === 'number' && typeof obj.nodeName === 'string' && typeof obj.isEqualNode === 'function';
}

function isA(typeName, value) {
  return Object.prototype.toString.apply(value) === '[object ' + typeName + ']';
}

function isAsymmetric(obj) {
  return !!obj && isA('Function', obj.asymmetricMatch);
}

function asymmetricMatch(a, b) {
  var asymmetricA = isAsymmetric(a),
      asymmetricB = isAsymmetric(b);

  if (asymmetricA && asymmetricB) {
    return undefined;
  }

  if (asymmetricA) {
    return a.asymmetricMatch(b);
  }

  if (asymmetricB) {
    return b.asymmetricMatch(a);
  }
}
/**
 * 深比對物件
 * @param a
 * @param b
 * @param aStack
 * @param bStack
 * @param customTesters
 * @param hasKey
 */


const eq = (a, b, aStack, bStack, customTesters, hasKey) => {
  customTesters = customTesters || [];
  var result = true;
  var asymmetricResult = asymmetricMatch(a, b);

  if (asymmetricResult !== undefined) {
    return asymmetricResult;
  }

  for (var i = 0; i < customTesters.length; i++) {
    var customTesterResult = customTesters[i](a, b);

    if (customTesterResult !== undefined) {
      return customTesterResult;
    }
  }

  if (a instanceof Error && b instanceof Error) {
    return a.message == b.message;
  }

  if (Object.is(a, b)) {
    return true;
  } // A strict comparison is necessary because `null == undefined`.


  if (a === null || b === null) {
    return a === b;
  }

  var className = Object.prototype.toString.call(a);

  if (className != Object.prototype.toString.call(b)) {
    return false;
  }

  switch (className) {
    case '[object Boolean]':
    case '[object String]':
    case '[object Number]':
      if (typeof a !== typeof b) {
        // One is a primitive, one a `new Primitive()`
        return false;
      } else if (typeof a !== 'object' && typeof b !== 'object') {
        // both are proper primitives
        return Object.is(a, b);
      } else {
        // both are `new Primitive()`s
        return Object.is(a.valueOf(), b.valueOf());
      }

    case '[object Date]':
      // Coerce dates to numeric primitive values. Dates are compared by their
      // millisecond representations. Note that invalid dates with millisecond representations
      // of `NaN` are not equivalent.
      return +a == +b;
    // RegExps are compared by their source patterns and flags.

    case '[object RegExp]':
      return a.source === b.source && a.flags === b.flags;
  }

  if (typeof a !== 'object' || typeof b !== 'object') {
    return false;
  } // Use DOM3 method isEqualNode (IE>=9)


  if (isDomNode(a) && isDomNode(b)) {
    return a.isEqualNode(b);
  } // Used to detect circular references.


  var length = aStack.length;

  while (length--) {
    // Linear search. Performance is inversely proportional to the number of
    // unique nested structures.
    // circular references at same depth are equal
    // circular reference is not equal to non-circular one
    if (aStack[length] === a) {
      return bStack[length] === b;
    } else if (bStack[length] === b) {
      return false;
    }
  } // Add the first object to the stack of traversed objects.


  aStack.push(a);
  bStack.push(b); // Recursively compare objects and arrays.
  // Compare array lengths to determine if a deep comparison is necessary.

  if (className == '[object Array]' && a.length !== b.length) {
    return false;
  } // Deep compare objects.


  var aKeys = keys(a, hasKey),
      key;
  var size = aKeys.length; // Ensure that both objects contain the same number of properties before comparing deep equality.

  if (keys(b, hasKey).length !== size) {
    return false;
  }

  while (size--) {
    key = aKeys[size]; // Deep compare each member

    result = hasKey(b, key) && eq(a[key], b[key], aStack, bStack, customTesters, hasKey);

    if (!result) {
      return false;
    }
  } // Remove the first object from the stack of traversed objects.


  aStack.pop();
  bStack.pop();
  return result;
};
/**
 * 深度比較 (toStrictEqual)
 * @param a
 * @param b
 * @param isStrictCheck 嚴格(default: false, 開啟則會檢查不可為將物件中的 undefined 視為不同)
 * @param options
 */


function deepCompare(a, b, isStrictCheck, options) {
  const customTesters = (options == null ? void 0 : options.customTesters) || [];
  return eq(a, b, [], [], customTesters, isStrictCheck ? hasKey : hasDefinedKey);
}

/**
 * 正則表達式條件參數
 */

const regPattern = {
  number: /^[\d]*$/,
  email: /^[A-Za-z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
  protocolDomain: /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}/g,
  domain: /(:(http(s)?:\/\/.))?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}/g
};
/**
 * 判定是否為空
 * @param value
 * @param checkOption
 * @returns {boolean}
 */

function isEmpty(value, checkOption) {
  var _checkOption$isZero, _checkOption$isFalse;

  const defaultCheckOption = {
    isZero: (_checkOption$isZero = checkOption == null ? void 0 : checkOption.isZero) != null ? _checkOption$isZero : true,
    isFalse: (_checkOption$isFalse = checkOption == null ? void 0 : checkOption.isFalse) != null ? _checkOption$isFalse : true
  };
  return value === undefined || value === null || defaultCheckOption.isFalse && (value === false || value === 'false') || defaultCheckOption.isZero && (value === 0 || value === '0') || !(value instanceof Date) && typeof value === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
}
/**
 * 判定是否不為空
 * @param value
 * @param checkOption
 * @returns {boolean}
 */

function isNotEmpty(value, checkOption) {
  var _checkOption$isZero2, _checkOption$isFalse2;

  const defaultCheckOption = {
    isZero: (_checkOption$isZero2 = checkOption == null ? void 0 : checkOption.isZero) != null ? _checkOption$isZero2 : true,
    isFalse: (_checkOption$isFalse2 = checkOption == null ? void 0 : checkOption.isFalse) != null ? _checkOption$isFalse2 : true
  };
  return !isEmpty(value, defaultCheckOption);
}
/**
 * 驗證日期格式為 YYYY-MM-DD
 * @param str
 * @returns {boolean}
 */

function isDate(str) {
  const re = new RegExp('^([0-9]{4})[/.-]{1}([0-9]{1,2})[/.-]{1}([0-9]{1,2})$');
  let infoValidation = true;
  const strDataValue = re.exec(str);

  if (strDataValue !== null) {
    let i;
    i = parseFloat(strDataValue[1]);

    if (i <= 0 || i > 9999) {
      /* 年 */
      infoValidation = false;
    }

    i = parseFloat(strDataValue[2]);

    if (i <= 0 || i > 12) {
      /* 月 */
      infoValidation = false;
    }

    i = parseFloat(strDataValue[3]);

    if (i <= 0 || i > 31) {
      /* 日 */
      infoValidation = false;
    }
  } else {
    infoValidation = false;
  }

  return infoValidation;
}
/**
 * 判斷是否為IP
 * @param ip
 * @returns {boolean}
 */

function isIP(ip) {
  const reg = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/; // @ts-ignore

  if (reg.test(ip) && RegExp.$1 < 256 && RegExp.$2 < 256 && RegExp.$3 < 256 && RegExp.$4 < 256) {
    return true;
  }

  return false;
}
/**
 * 判斷是否為JSON
 * @param jsonString string
 */

function isJSON(jsonString) {
  try {
    const obj = JSON.parse(jsonString);

    if (obj && typeof obj === 'object' && obj !== null) {
      return true;
    }
  } catch (err) {
    return false;
  }

  return false;
}

export { deepCompare, isDate, isEmpty, isIP, isJSON, isNotEmpty, regPattern };
//# sourceMappingURL=equal.modern.js.map
